import { render } from "./NewPromotion.vue?vue&type=template&id=4a95153a&scoped=true"
import script from "./NewPromotion.vue?vue&type=script&lang=js"
export * from "./NewPromotion.vue?vue&type=script&lang=js"

import "./NewPromotion.vue?vue&type=style&index=0&id=4a95153a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4a95153a"

export default script